export var UrlPathOfAdminSection = "/admin3";
export var UrlPathOfPublicSection = "/dancesport";
export var UrlPathOfApiLocation = ""; // https://www.csts.cz for testing of development UI with production API
